<template>
  <div>
    <div class="q-mb-lg">
      <ReferrerReportWebsite />
    </div>
  </div>
</template>

<script>
import ReferrerReportWebsite from '@client/components/reports/referrer-report/website';

export default {
  components: {
    ReferrerReportWebsite
  },
  name: 'ReportsWebsite',
  metaInfo: {
    title: 'AutoBook Pro - Report - Website'
  },
  data() {
    return {
      tab: 'mails'
    };
  }
};
</script>
<style lang="scss"></style>
